import { useSwipeable } from 'react-swipeable'

// https://github.com/FormidableLabs/react-swipeable/blob/a7e596a75167cd5efd92f30818ecb1d9044d76cd/migration.md#swipeable-simple-example
export const Swipeable = ({ children, ...props }) => {
  const handlers = useSwipeable(props)
  return <div {...handlers}>{children}</div>
}
